import { tv } from 'tailwind-variants'

export const spinnerVariants = tv({
  base: 'animate-spin',
  variants: {
    color: {
      green: '',
      red: '',
    },
    variant: {
      primary: '',
      secondary: '',
      tertiary: '',
    },
  },
  compoundVariants: [
    {
      color: 'green',
      variant: 'primary',
      className: 'text-white',
    },
    {
      color: 'green',
      variant: 'secondary',
      className: 'text-green-base',
    },
    {
      color: 'red',
      variant: 'primary',
      className: 'text-white',
    },
    {
      color: 'red',
      variant: 'secondary',
      className: 'text-red-base',
    },
  ],
})

export const buttonVariants = tv({
  base: 'font-body flex cursor-pointer items-center justify-center gap-1 text-sm leading-none font-bold transition-all duration-300 outline-none hover:scale-[0.98] hover:shadow-none focus:ring-1 disabled:pointer-events-none disabled:cursor-not-allowed',
  variants: {
    isDashed: {
      true: 'border-dashed',
      false: 'border-solid',
    },
    isLoading: {
      true: '',
      false: '',
    },
    isRounded: {
      true: 'w-fit rounded-full p-1',
      false: 'h-11 w-full rounded-lg px-3',
    },
    color: {
      green: '',
      red: '',
    },
    variant: {
      primary: 'border',
      secondary: 'border',
      tertiary: '',
    },
  },
  compoundVariants: [
    {
      color: 'green',
      variant: 'primary',
      className:
        'border-accent-1 bg-accent-1 ring-accent-1 hover:bg-accent-1/70 text-white shadow-lg disabled:opacity-50 disabled:shadow-none',
    },
    {
      color: 'green',
      variant: 'secondary',
      className:
        'border-accent-1 text-accent-1 ring-accent-1 hover:bg-accent-1/20 disabled:bg-[transparent] disabled:opacity-50',
    },
    {
      color: 'green',
      variant: 'tertiary',
      className: 'text-accent-1 ring-accent-1 hover:bg-accent-1/20 bg-[transparent] disabled:opacity-50',
    },
    {
      color: 'red',
      variant: 'primary',
      className:
        'border-error bg-error ring-error hover:bg-error/60 text-white shadow-lg disabled:opacity-50 disabled:shadow-none',
    },
    {
      color: 'red',
      variant: 'secondary',
      className: 'border-error text-error ring-error hover:bg-error/20 bg-[transparent] disabled:opacity-50',
    },
    {
      color: 'red',
      variant: 'tertiary',
      className: 'text-error ring-error hover:bg-error/20 bg-[transparent] disabled:opacity-50',
    },
  ],
  defaultVariants: {
    color: 'green',
    variant: 'primary',
    isLoading: false,
  },
})

export const iconVariants = tv({
  variants: {
    color: {
      green: '',
      red: '',
    },
    variant: {
      primary: '',
      secondary: '',
      tertiary: '',
    },
  },
  compoundVariants: [
    {
      color: 'green',
      variant: 'primary',
      className: 'text-white',
    },
    {
      color: 'green',
      variant: 'secondary',
      className: 'text-accent-1',
    },
    {
      color: 'red',
      variant: 'primary',
      className: 'text-white',
    },
    {
      color: 'red',
      variant: 'secondary',
      className: 'text-error',
    },
  ],
  defaultVariants: {
    color: 'green',
    variant: 'primary',
  },
})
